import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Small live indicator that reflects whether the forex market is currently open.
 * Polls /market/rates every ~15 seconds.
 */
export default function MarketStatusDot() {
  const [open, setOpen] = useState(null);  // null = unknown, avoids flash

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const { data } = await api.get("/market/rates");
        if (mounted && data.rates?.[0]) setOpen(!!data.rates[0].market_open);
      } catch { /* ignore */ }
    };
    load();
    const t = setInterval(load, 15000);
    return () => { mounted = false; clearInterval(t); };
  }, []);

  if (open === null) {
    return <div data-testid="market-status-indicator" className="w-24 h-4" />;
  }

  return (
    <div
      data-testid="market-status-indicator"
      className={`flex items-center gap-2 text-xs ${open ? "text-muted-foreground" : "text-warning"}`}
    >
      <span
        className={`inline-block w-2 h-2 rounded-full ${open ? "" : "bg-warning"}`}
        style={open ? { background: "hsl(var(--profit))", animation: "livePulse 1.5s ease-in-out infinite" } : {}}
      />
      <span className="font-mono-num uppercase tracking-widest">
        {open ? "Market Live" : "Market Closed"}
      </span>
    </div>
  );
}
